module.exports = __webpack_public_path__ + "static/media/blog.ce96b7f2.png";